export * as badges from '@wix/auto_sdk_members_badges/schemas';
export * as badgesV2 from '@wix/auto_sdk_members_badges-v-2/schemas';
export * as badgeAssignments from '@wix/auto_sdk_members_badge-assignments/schemas';
export * as authentication from '@wix/auto_sdk_members_authentication/schemas';
export * as membersAbout from '@wix/auto_sdk_members_members-about/schemas';
export * as userMember from '@wix/auto_sdk_members_user-member/schemas';
export * as customFields from '@wix/auto_sdk_members_custom-fields/schemas';
export * as customFieldApplications from '@wix/auto_sdk_members_custom-field-applications/schemas';
export * as customFieldSuggestions from '@wix/auto_sdk_members_custom-field-suggestions/schemas';
export * as defaultPrivacy from '@wix/auto_sdk_members_default-privacy/schemas';
export * as members from '@wix/auto_sdk_members_members/schemas';
export * as memberPrivacySettings from '@wix/auto_sdk_members_member-privacy-settings/schemas';
export * as memberReport from '@wix/auto_sdk_members_member-report/schemas';
export * as memberRoleDefinition from '@wix/auto_sdk_members_member-role-definition/schemas';
export * as memberToMemberBlock from '@wix/auto_sdk_members_member-to-member-block/schemas';
export * as authorization from '@wix/auto_sdk_members_authorization/schemas';
export * as memberFollowers from '@wix/auto_sdk_members_member-followers/schemas';
